import React, { useEffect } from "react";
import { useDispatch, useSelector as useReduxSelector } from "react-redux";
import BranchLink from "web/react/components/branch-link/branch-link";
import GenericStickyModal from "web/react/components/generic-sticky-modal/generic-sticky-modal";
import ImageCarousel from "web/react/components/image-carousel/image-carousel";
import { closeS4LModal } from "web/redux/ducks/send-to-app-modal";
import { ReduxStoreState } from "web/redux/store";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import { RawBranchLink } from "web/script/utils/branch-io";
import image1 from "./images/s4l-image1.png";
import image2 from "./images/s4l-image2.png";
import image3 from "./images/s4l-image3.png";
import styles from "./save-for-later-send-to-app-modal.css";

function extractState(state: ReduxStoreState): boolean {
    return state.sendToAppModalReducer.S4LModalIsOpen;
}

function SaveForLaterSendToAppModal(): JSX.Element {
    const dispatch = useDispatch();
    const S4LModalIsOpen = useReduxSelector(extractState);

    // "Group your favourite items into your own personal lists"
    const title = gettext("save_for_later.app_overlay_block.title_1");
    const analyticsEventLabel = "s4l_app_signup";
    const branchLink = RawBranchLink.AppSignupS4L;

    // "Continue on the Lyst app for free"
    const downloadCTA = gettext("app_overlay_block.continue.cta");

    function onModalClose(): void {
        analytics.event("s4l_app_to_web_overlay", "modal_dismissed", analyticsEventLabel);
        dispatch(closeS4LModal());
    }

    useEffect(() => {
        if (S4LModalIsOpen) {
            analytics.event("s4l_app_to_web_overlay", "modal_open", analyticsEventLabel);
        }
    }, [S4LModalIsOpen]);

    const sliderContent = [
        {
            image: image1,
        },
        {
            image: image2,
        },
        {
            image: image3,
        },
    ];

    function imageElement(itemContent): JSX.Element {
        const { image } = itemContent;
        return (
            <div className={styles.iconContainer}>
                <img src={image} className={styles.icon} alt="Lyst app" />
            </div>
        );
    }
    const imageElements: JSX.Element[] = [];
    for (let i = 0; i < sliderContent.length; ++i) {
        imageElements.push(imageElement(sliderContent[i]));
    }

    return (
        <GenericStickyModal isOpen={S4LModalIsOpen} onClose={onModalClose}>
            <>
                <h1 className={styles.title}>{title}</h1>
                <div className={styles.carouselContainer}>
                    <ImageCarousel
                        carouselItems={imageElements}
                        showDots={true}
                        scrollTime={2000}
                        transition={"fade"}
                    />
                </div>
                <BranchLink
                    title={downloadCTA}
                    className={styles.button}
                    branchLink={branchLink}
                    eventLabel={analyticsEventLabel}
                    showAppIcon={true}
                    primaryButton
                />
            </>
        </GenericStickyModal>
    );
}

export default SaveForLaterSendToAppModal;
